import React, { Component } from 'react';

import Modal from "../../../../component/modal/ModalTemplate";
import TextInput from "../../../../component/input/TextInput";

class UpdatePWModal extends Component {
    constructor(props){
        super(props);
    }

    render() {
        const { open, handleClose, password1, password2, setValue } = this.props;
        const { updatePasswordAction } = this.props;

        return (
            <>
                <Modal
                    open={open}
                    handleClose={handleClose}
                    modalTitle={"아이디 / 비밀번호 찾기"}
                    className={"react-modal"}
                >
                    <div className="modal-body">
                        <div className={"container"}>
                            <div className="row mb-3">
                                <label htmlFor="password1" className="col-sm-4 col-form-label">새 비밀번호</label>
                                <div className="col-sm-8">
                                    <TextInput
                                        className="form-control"
                                        type="password"
                                        id="password1"
                                        value={password1}
                                        placeholder="새 비밀번호를 입력해주세요"
                                        onChange={setValue}
                                    />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="password2" className="col-sm-4 col-form-label">새 비밀번호 확인</label>
                                <div className="col-sm-8">
                                    <TextInput
                                        className="form-control"
                                        type="password"
                                        id="password2"
                                        value={password2}
                                        placeholder="비밀번호 재확인"
                                        onChange={setValue}
                                        onKeyDown={updatePasswordAction}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"modal-footer justify-content-center"}>
                        <button className={"btn btn-primary btn-md"} onClick={updatePasswordAction}>변경하기</button>
                    </div>
                </Modal>
            </>
        )
    }
}

export default UpdatePWModal;
